// 3rd party imports
import * as React from 'react';
import { Link } from 'react-router-dom';
import { inject } from 'mobx-react';
import { LocalizedComponentProps, LocalizedText, withLocalization } from '@shared-ui/localization-context';

// bernie
import { ContextStore, AnalyticsStore } from 'bernie-core';

// ui
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { UitkHeading, UitkText } from 'uitk-react-text';
import { UitkLayoutFlex } from 'uitk-react-layout-flex';
import { UitkSpacing } from 'uitk-react-spacing';

// util
import { modifyLocaleParam } from '../util/LocaleParamTransformer';

export interface ErrorMessageProps extends LocalizedComponentProps {
  context?: ContextStore;
  analytics?: AnalyticsStore;
}

@withLocalization
@inject('context', 'analytics')
export class ErrorMessage extends React.Component<ErrorMessageProps> {
  constructor(props) {
    super(props);
  }

  public render() {
    const { analytics } = this.props;
    const referrerId = 'hub.error.page';

    return (
      <UitkLayoutFlex direction="column" alignItems="center" justifyContent="center">
        <UitkSpacing margin={{ blockend: 'three' }}>
          <UitkIcon name="sentiment_2" size={UitkIconSize.XLARGE} className="ErrorMessage__Icon" />
        </UitkSpacing>
        <UitkSpacing margin={{ blockend: 'three' }}>
          <UitkText size={700} weight="bold">
            Something went wrong
          </UitkText>
        </UitkSpacing>
        <UitkText>Please try again in a few minutes</UitkText>
      </UitkLayoutFlex>
    );
  }
}
